import { render, staticRenderFns } from "./BQdt.vue?vue&type=template&id=3a13e42e"
import script from "./BQdt.vue?vue&type=script&lang=js"
export * from "./BQdt.vue?vue&type=script&lang=js"
import style0 from "./BQdt.vue?vue&type=style&index=0&id=3a13e42e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports